import { useState, useRef, useCallback } from 'react';

export function useColumnResize(initialWidths: number[]) {
  const [widths, setWidths] = useState<number[]>(initialWidths);
  const widthsRef = useRef<number[]>(initialWidths);

  const startResize = useCallback((colIndex: number, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = widthsRef.current[colIndex];

    const onMouseMove = (e: MouseEvent) => {
      const newWidth = Math.max(48, startWidth + (e.clientX - startX));
      const next = [...widthsRef.current];
      next[colIndex] = newWidth;
      widthsRef.current = next;
      setWidths([...next]);
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }, []);

  const gridTemplate = widths.map(w => `${w}px`).join(' ');
  const totalWidth = widths.reduce((a, b) => a + b, 0);

  return { widths, gridTemplate, totalWidth, startResize };
}
